import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { OffboardingService } from './offboarding.service';

const PERMISSION_KEY = 'workflowPermission';
const FORBIDDEN_ROUTE = '/dashboard/home';

@Injectable()
export class WorkflowPageGuard implements CanActivate {
  constructor(private api: OffboardingService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.api.permissions().map(permissions =>
      !!permissions && permissions[route.data[PERMISSION_KEY]] === true)
      .catch(() => Observable.of(false)).map(allowed => {
        if (!allowed) { this.router.navigate([FORBIDDEN_ROUTE]); }
        return allowed;
      });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/workflow-page.guard.ts